import { freeListingContract } from './freeListingContract';
import { packages } from './packages';
import { preferences } from './preferences';
import { sellerDashboard } from './sellerDashboard';
import { sitewide } from './sitewide';

export const tracking = {
  freeListingContract,
  packages,
  preferences,
  sellerDashboard,
  sitewide,
};
